import { IState } from '../reducers'

export const getAppIsInitialize = (state: IState): boolean => state.app.isInitialize
export const getAppIsMobile = (state: IState): boolean => state.app.isMobile
export const getAppMenuIsOpen = (state: IState): boolean => state.app.menuIsOpen
export const getReferencesFilter = (state: IState): any => state.app.referencesFilter
export const getMonths = (state: IState): any => state.app.months
export const getApplication = (state: IState): any => state.app.application
export const getEnName = (state: IState): any => state.app.en_name